import { flatten } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import {
  selectIntegrationConfig_AITA,
  selectShopifyStoreConfig,
} from "store/modules/workspace/workspace.selectors";
import { AllActionsByGroup as _AllActionsByGroup } from "../action-editor/actions-registry";

export const useValidActions = ({
  includedActionGroups,
  excludeActions,
}: {
  excludeActions?: string[];
  includedActionGroups?: string[];
}) => {
  const shopifyStoreConfig = useSelector(selectShopifyStoreConfig);
  const aita = useSelector(selectIntegrationConfig_AITA);
  const isAitaEnabled = !!aita;

  const AllActionsByGroup = useMemo(() => {
    const isShopifyConnected = shopifyStoreConfig?.isActive;
    return _AllActionsByGroup
      .filter((item) =>
        item.label === "Shopify Actions" ? isShopifyConnected : true,
      )
      .filter((item) => {
        if (includedActionGroups) {
          if (includedActionGroups.includes(item.label)) {
            return true;
          }
          return false;
        }
        return true;
      })
      .map((item) => ({
        ...item,
        actions: item.actions.filter((action) => {
          if (action === "ACTIVATE_AI_TRAVEL_AGENT" && !isAitaEnabled) {
            return false;
          }
          return true;
        }),
      }));
  }, [includedActionGroups, isAitaEnabled, shopifyStoreConfig?.isActive]);

  const AllValidActions = useMemo(() => {
    return flatten(
      AllActionsByGroup.map((item) =>
        item.actions.filter((action) => {
          if (excludeActions && excludeActions.includes(action)) {
            return false;
          }
          return true;
        }),
      ),
    );
  }, [AllActionsByGroup, excludeActions]);

  return { AllValidActions, AllActionsByGroup };
};
